import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useClient } from "../../hooks/ClientProvider";

export const useInactivityModal = () => {
  const { clearClient } = useClient();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState({ title: "", message: "" });

  const handleTicketExpired = useCallback((event: any) => {
    const { message } = event.detail; 

    setModalData({ 
      title: "Atendimento Expirado", 
      message 
    });
    setIsOpen(true);
  }, []);


  useEffect(() => {
    window.addEventListener("ticket-expired", handleTicketExpired);

    return () => {
      window.removeEventListener("ticket-expired", handleTicketExpired);
    };
  }, [handleTicketExpired]); 

  const handleConfirm = async () => {
    await clearClient?.();
    setIsOpen(false);
    navigate("/home", { replace: true });
  };

  return {
    isOpen,
    modalData,
    handleConfirm,
  };
};